import { Typography, styled } from '@mui/material';

const StyledCounterLine = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(10),
  fontWeight: 500,
  lineHeight: 1.3,
  [theme.breakpoints.up('sm')]: {
    fontSize: theme.typography.pxToRem(14)
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: theme.typography.pxToRem(16)
  }
}));

export default StyledCounterLine;
